module.exports = __webpack_public_path__ + "img/EmptyFile.85f8533d.svg";